//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Object.js";
import "../no/ErrorList.js";
import "../MechanicalRouting/MechanicalRouting.RoutingManager.js";
let d=[[],[[["part","nConnectedPorts","connectedPorts1","connectedPorts2"],"GetConnectedPorts",{},1,0],[["part","nConnectedPorts","connectedPorts1","connectedPorts2"],"GetConnectedPortsFromComponent",{},1,0],[["containerTag","componentTag","componentType","nConnectedComponents","connectedComponents","errorList"],"GetComponentsConnectedToComponent",{},3,0]],[]];
SPLM.MechanicalRouting.ConnectivityService = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.MechanicalRouting.ConnectivityService";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.ConnectivityService.ComponentType = Object.freeze({
    "Fitting" : "Fitting", "Stock" : "Stock", "Any" : "Any"});

export default SPLM;